import React, { useEffect, useState } from 'react';  
import axiosClient, { getData, postData, encodeId, decodeId, } from '../../global/Globalapi';
import ProductView from './ProductView';
import { useParams } from 'react-router-dom';
import { storeEncodedLead } from "../../global/Globalfunction";

const Step4 = ({ id: propId, type, handleCancelAdd }) => {
  // const { id: routeId } = useParams();
  // const masterproductid = propId || routeId;
const { id: routeId } = useParams();

// Normalize incoming id: accept numeric or base64 that decodes to numeric.
function safeAtob(value) {
  try {
    return atob(value);
  } catch (e) {
    return null;
  }
}

function normalizeId(routeId, propId) {
  if (propId && /^\d+$/.test(propId)) return propId;
  if (propId) {
    const d = safeAtob(propId);
    if (d && /^\d+$/.test(d)) return d;
  }
  if (routeId && /^\d+$/.test(routeId)) return routeId;
  if (routeId) {
    const d2 = safeAtob(routeId);
    if (d2 && /^\d+$/.test(d2)) return d2;
  }
  return null;
}

const masterproductid = normalizeId(routeId, propId);

  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVariants, setSelectedVariants] = useState({});
  const [error, setError] = useState(null);
  const [currentid, setCurrentid] = useState(masterproductid);
  const [isVariantLoading, setIsVariantLoading] = useState(false);
  const [variantError, setVariantError] = useState(null);
  const [childid, setChildid] = useState(null);
  const [childProduct, setChildProduct] = useState(null);
  const [childoptions, setChildOptions] = useState([]);
  const [selectedChildOptions, setSelectedChildOptions] = useState({});

  const baseURL = axiosClient.defaults.baseURL;

  // Fetch product details
  const fetchProduct = async (id, Productsetter) => {
    try {
      const res = await getData(`/product/${id}`);
      if (res.data) {
        Productsetter(res.data);
      }
      console.log('Fetched product:', res.data);
    } catch (err) {
      console.error("Failed to fetch product:", err);
      setError(err.response?.data?.message || "An error occurred while fetching product details.");
    }
  };
////////////////////////////////////////////////
// 📌 STORE LEADS ONLY WHEN VISITING PRODUCT PAGE DIRECTLY WITH AFFILIATE URL
useEffect(() => {
  if (type !== "Main Page") return;  // ❌ Block Step4 in other contexts

  const url = window.location.href;
  const params = new URL(url).searchParams;

  const campaign_id = params.get("campaign_id");
  const affiliate_user_id = params.get("affiliate_user_id");
  const affiliated_campaign_id = params.get("affiliated_campaign_id");

  // ❌ If no affiliate params → do not store leads
  if (!campaign_id && !affiliate_user_id && !affiliated_campaign_id) return;

  console.log("Storing lead from product page…");

  storeEncodedLead(url); // Pass full URL

}, [type]);

  // Set main image when product or child product changes
  useEffect(() => {
    if (childProduct && childProduct.images && childProduct.images.length > 0) {
      setMainImage(`${baseURL}/uploads/${childProduct.images[0].file_name}`);
    } else if (product && product.images && product.images.length > 0) {
      setMainImage(`${baseURL}/uploads/${product.images[0].file_name}`);
    } else {
      setMainImage("https://via.placeholder.com/300x200?text=No+Image");
    }
  }, [product, childProduct]);

  // Fetch product options/attributes and GROUP them by attribute name
  const fetchProductOptions = async (id, Optionsetter) => {
    try {
      const response = await getData(`/product/product_options/${id}`);
      console.log('Raw fetched options:', response.data);
      
      // Group attributes by Label (attribute name)
      const groupedOptions = {};
      
      response.data.forEach(item => {
        const label = item.Label;
        
        if (!groupedOptions[label]) {
          // First occurrence - create the group
          groupedOptions[label] = {
            ...item,
            Options: item.Options || '' // Start with this value
          };
        } else {
          // Subsequent occurrences - append to Options
          const existingOptions = groupedOptions[label].Options;
          const newOption = item.Options;
          
          // Combine options with comma separator
          if (newOption && !existingOptions.split(',').map(v => v.trim()).includes(newOption.trim())) {
            groupedOptions[label].Options = existingOptions + ',' + newOption;
          }
        }
      });
      
      // Convert back to array
      const groupedArray = Object.values(groupedOptions);
      console.log('Grouped options:', groupedArray);
      
      Optionsetter(groupedArray);
    } catch (err) {
      console.error("Failed to fetch product options:", err);
      setError(err.response?.data?.message || "An error occurred while fetching options.");
    }
  };

  // Set default variant selections when product loads
  useEffect(() => {
    if (product?.has_variant === 1 && options.length > 0) {
      if (Object.keys(selectedVariants).length === 0) {
        const defaults = {};
        const variantAttributes = options.filter(opt => opt.Attribute_Category === 'Variant_Deterministic');
        
        variantAttributes.forEach(option => {
          if (option.Options && typeof option.Options === 'string') {
            const firstOption = option.Options.split(',')[0].trim();
            defaults[option.Label] = { value: firstOption, optionData: option };
          }
        });
        
        setSelectedVariants(prev => ({ ...defaults, ...prev }));
      }
    }
  }, [product, options]);

  // Handle variant selection (toggle selection)
  const handleVariantSelect = (option, selectedValue, statesetter) => {
    const label = option.Label;

    statesetter(prev => {
      const isCurrentlySelected = prev[label]?.value === selectedValue;

      if (isCurrentlySelected) {
        const newState = { ...prev };
        delete newState[label];
        return newState;
      } else {
        return {
          ...prev,
          [label]: { value: selectedValue, optionData: option }
        };
      }
    });
  };

  // Fetch all data (product + options)
  const fetchAll = async (id, setProduct, setOptions) => {
    setLoading(true);
    setError(null);

    await fetchProduct(id, setProduct);
    await fetchProductOptions(id, setOptions);

    setLoading(false);
  };

  // Initial fetch
  useEffect(() => {
    if (!currentid) {
      setLoading(false);
      return;
    }

    fetchAll(currentid, setProduct, setOptions);
  }, [currentid]);

  // Debug logs
  useEffect(() => {
    console.log('Selected Variants:', selectedVariants);
  }, [selectedVariants]);

  useEffect(() => {
    console.log('Processed Options:', options);
  }, [options]);

  // Filter common and variant attributes
  const commonAttributes = options.filter(opt => opt.Attribute_Category === 'Common');
  const variantAttributes = options.filter(opt => opt.Attribute_Category === 'Variant_Deterministic');

  // Find matching variant when all variant options are selected
  useEffect(() => {
    const variantDefiningOptions = options.filter(opt => opt.Attribute_Category === 'Variant_Deterministic');
    const selectedCount = Object.keys(selectedVariants).length;
    const totalRequired = variantDefiningOptions.length;
    
    if (totalRequired === 0) return;
    
    // Reset child data when selections change
    setChildProduct(null);
    setChildOptions([]);
    setChildid(null);
    setSelectedChildOptions({});

    if (selectedCount === totalRequired) {
      findMatchingVariant();
    } else if (product?.Parent_Id !== null) {
      setCurrentid(masterproductid);
      setVariantError(null);
    }
  }, [selectedVariants, options]);

  // Loading and error states
  if (loading) return <div className="text-center p-8">Loading...</div>;
  if (error) return <div className="text-center p-8 text-red-500">Error: {error}</div>;
  if (!product) return <div className="text-center p-8">Product not found.</div>;

  // Determine which images to display
  const imagesToDisplay = (childProduct?.images?.length > 0)
    ? childProduct.images
    : product.images;
  const thumbnails = imagesToDisplay?.map(img => `${baseURL}/uploads/${img.file_name}`) || [];

  // Find matching variant
  const findMatchingVariant = async () => {
    setIsVariantLoading(true);
    setVariantError(null);

    // Build combo array from selected variants (sorted by label)
    const comboArray = Object.entries(selectedVariants)
      .sort(([labelA], [labelB]) => labelA.localeCompare(labelB))
      .map(([_, data]) => data.value);

    console.log("Searching for combo array:", comboArray);
    console.log("Full payload:", {
      parentId: masterproductid,
      combo: comboArray,
    });

    try {
      const response = await postData('/find_variant', {
        parentId: masterproductid,
        combo: comboArray,
      });

      if (response.data && response.data.product_id) {
        const foundChildId = response.data.product_id;
        setChildid(foundChildId);
        console.log('Found variant ID:', foundChildId);
        
        // Fetch child product and its options
        await fetchAll(foundChildId, setChildProduct, setChildOptions);
      } else {
        setVariantError('This specific combination is not available.');
        setChildProduct(null);
        setChildOptions([]);
      }
    } catch (err) {
      console.error("Failed to find variant:", err);
      setVariantError('An error occurred while checking availability.');
    } finally {
      setIsVariantLoading(false);
    }
  };

  return (
    <div>
      <ProductView
        product={product}
        mainImage={mainImage}
        thumbnails={thumbnails}
        setMainImage={setMainImage}
        variantAttributes={variantAttributes}
        commonAttributes={commonAttributes}
        selectedVariants={selectedVariants}
        handleVariantSelect={handleVariantSelect}
        childProduct={childProduct}
        childOptions={childoptions}
        childid={childid}
        selectedChildOptions={selectedChildOptions}
        setSelectedChildOptions={setSelectedChildOptions}
        setSelectedVariants={setSelectedVariants}
        type={type}
        id={masterproductid}
        handleCancelAdd={handleCancelAdd}
        isVariantLoading={isVariantLoading}
        variantError={variantError}
      />
    </div>
  );
};

export default Step4;